import companyPlaceholder from "./img/company.png";
import defaultPlaceholder from "./img/default.png";
import userPlaceholder from "./img/user.png";

type AppImage = { url: string } | null;

interface ImageReturn {
  onError: (e: React.SyntheticEvent<HTMLImageElement, Event>) => void;
  src: string;
}

export const getImage = (image: AppImage, placeholder: string = defaultPlaceholder): ImageReturn => {
  return {
    onError: (e: React.SyntheticEvent<HTMLImageElement, Event>): void => {
      e.currentTarget.src = placeholder;
    },
    src: image && image.url ? image.url : placeholder,
  };
};

export const getCompanyImage = (image: AppImage): ImageReturn => {
  return getImage(image, companyPlaceholder);
};

export const getUserImage = (image: AppImage): ImageReturn => {
  return getImage(image, userPlaceholder);
};
